import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';
let pricingSwiperWr = document.querySelectorAll('.pricing-swiper-wr');
pricingSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    swiperOnResize('(max-width: 1023px)', swiperEl, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        540: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 2,
        },
        1440: {
          slidesPerView: 3,
        },
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });
  }
});

function setEqualHeights() {
  const pricingItemTop = document.querySelectorAll(
    '.pricing-section__item-top'
  );
  let maxHeight = 0;

  pricingItemTop.forEach((item) => {
    item.style.minHeight = ''; // Сбрасываем высоту перед пересчётом
    const itemHeight = item.offsetHeight;
    if (itemHeight > maxHeight) {
      maxHeight = itemHeight;
    }
  });

  pricingItemTop.forEach((item) => {
    item.style.minHeight = `${maxHeight}px`;
  });
}

if (document.querySelector('.pricing-section__item-top')) {
  setEqualHeights();

  window.addEventListener('resize', setEqualHeights);
}
